export default __webpack_public_path__ + "static/media/amsterdam-2x.0af2de13.webp";